/* eslint-disable */

/**
 * @note this file is auto-generated from running "npm run import-zebralist".
 * Please do not manually write to this file.
 */
export const ZEBRALIST = {
	"DYNAMIC": [],
	"STATIC": []
};